import { CHECKOUT_CART_MACHINE_ID } from './checkoutCart/id';

export enum CHECKOUT_TRANSITIONS {
  START_CHECKOUT = 'START_CHECKOUT',
  ENABLE_CHECKOUT = 'CAN_CHECKOUT',
  RESTART = 'RESTART',
  /**
   * User account is created and has an omsId (= is created and ready to be handled in the OMS).
   */
  USER_READY = 'USER_READY',
  SELECT_SHIPPING_ADDRESS = 'SELECT_SHIPPING_ADDRESS',
  SELECT_SHIPPING_METHOD = 'SELECT_SHIPPING_METHOD',
  SELECT_BILLING_ADDRESS = 'SELECT_BILLING_ADDRESS',
  SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD',
  COMPLETE_CHECKOUT = 'COMPLETE_CHECKOUT',
  START_ADDING_ADDRESS = 'START_ADDING_ADDRESS',
  ADD_COUPON = 'ADD_COUPON',
  CART_SYNC_DONE = `done.invoke.${CHECKOUT_CART_MACHINE_ID}`,
}
